import { createSlice } from "@reduxjs/toolkit";
import { getBKExportSettings, saveBKExportSettings } from "../thunks/bkExportSettingsThunks";
import { BKExportSettingsFormData } from "../../models/BKExportSettings.model";

interface BKExportSettingsState {
  loading: boolean;
  error: string | null;
  success: boolean;
  message: string;
  bkSetting_ID: number | null;
  bkSetting: BKExportSettingsFormData | null;
}

const initialState: BKExportSettingsState = {
  loading: false,
  error: null,
  success: false,
  message: "",
  bkSetting_ID: null,
  bkSetting:null
};

const bkExportSettingsSlice = createSlice({
  name: "bkExportSettings",
  initialState,
  reducers: {
    clearMessages: (state) => {
      state.error = null;
      state.success = false;
      state.message = "";
    },
    resetBKExportSettingsState: (state) => {
      Object.assign(state, initialState);
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(saveBKExportSettings.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
        state.message = "";
      })
      .addCase(saveBKExportSettings.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.message = action.payload.message || "הגדרות הנה\"ח נשמרו בהצלחה";
        state.bkSetting_ID = action.payload.bkSetting_ID;
        state.error = null;
      })
      .addCase(saveBKExportSettings.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload || "שגיאה בשמירת הגדרות הנה\"ח";
        state.message = "";
      })
    .addCase(getBKExportSettings.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
        state.message = "";
    })
      .addCase(getBKExportSettings.fulfilled, (state, action) => {  
        state.loading = false;
        state.success = true;
        state.message = action.payload.message || "הגדרות הנה\"ח נטענו בהצלחה";
        state.bkSetting = action.payload;
        state.error = null;
      })
      .addCase(getBKExportSettings.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload || "שגיאה בטעינת הגדרות הנה\"ח";
        state.message = "";
      });
  },
});

export const { clearMessages, resetBKExportSettingsState } =
  bkExportSettingsSlice.actions;

export default bkExportSettingsSlice.reducer;

// ===== SELECTORS =====

export const selectBKExportSettingsLoading = (state: {
  bkExportSettings: BKExportSettingsState;
}) => state.bkExportSettings.loading;

export const selectBKExportSettingsError = (state: {
  bkExportSettings: BKExportSettingsState;
}) => state.bkExportSettings.error;

export const selectBKExportSettingsSuccess = (state: {
  bkExportSettings: BKExportSettingsState;
}) => state.bkExportSettings.success;

export const selectBKExportSettingsMessage = (state: {
  bkExportSettings: BKExportSettingsState;
}) => state.bkExportSettings.message;

export const selectBKExportSettingsId = (state: {
  bkExportSettings: BKExportSettingsState;
}) => state.bkExportSettings.bkSetting_ID;
